import { useState, useEffect } from "react";
import { useAppDispatch, useAppSelector } from "src/hooks/redux";
import _ from "lodash";
import { selectUsers, selectCurrentUser } from "src/modules/users/selector";
import { UserAvatar } from "src/components/ui/avatar/Avatar";
import { TooltipItem } from "src/utils/Tooltip";
import { addItemRequest, getItemsRequest, updateItemRequest } from "src/modules/spItems/api";
import {
  copiesCardDocumentListName,
  historyChangeFieldsDocumentListName,
  myDocumentsListName,
  versionsByDocumentListName,
} from "src/api/config";
import moment from "moment";
import { docStatuses } from "src/api/config/systemSwitch";
import { containsAllIds } from "src/constants";
import { addUsers } from "src/modules/users/actions";
import { RootState } from "src/store/rootReducer";

type Props = {
  documentCardID: any;
  versionView: any;
};

const CopiesCard = (props: Props) => {
  const dispatch = useAppDispatch();
  const { documentCardID, versionView } = props;
  const [copies, setCopies] = useState<any>([]);
  const [create, setCreate] = useState(false);
  const [edit, setEdit] = useState(false);
  const [editData, setEditData] = useState<any>(null);
  const [copyFields, setCopyFields] = useState([
    {
      type: "input",
      key: "Title",
      require: true,
      title: "№ версии",
      disabled: true,
      placeholder: "№ версии",
      width: "w-full",
    },
    {
      type: "input",
      key: "CopyNum",
      require: true,
      disabled: true,
      title: "№ копии",
      placeholder: "№ копии",
      width: "w-full",
    },
    {
      type: "peoplePicker",
      require: true,
      single: true,
      key: "From",
      current: true,
      title: "Кем выдан",
      placeholder: "Кем выдан",
      width: "w-full",
    },
    {
      type: "peoplePicker",
      require: true,
      single: true,
      key: "For",
      current: false,
      title: "Кому выдан",
      placeholder: "Кому выдан",
      width: "w-full",
    },
    {
      type: "date",
      require: true,
      default: {
        startDate: new Date(),
        endDate: new Date(),
      },
      key: "DateIssue",
      title: "Дата выдачи",
      placeholder: "Выберите дату",
      width: "w-full",
    },
    {
      type: "date",
      require: false,
      key: "Take",
      title: "Изъят",
      placeholder: "Выберите дату",
      width: "w-full",
    },
    {
      type: "input",
      key: "Comment",
      require: false,
      title: "Комментарий",
      placeholder: "Комментарий",
      width: "w-full",
    },
  ]);
  const [formData, setFormData] = useState<any>(null);
  const [defaultValues, setDefaultValues] = useState<any>({});
  const [indexVersion, setIndexVersion] = useState(1);
  const users: any = useAppSelector(selectUsers);
  const statusUsers: string = useAppSelector((state: RootState) => state.users.status);
  const currentUser = useAppSelector(selectCurrentUser);
  const [card, setCard] = useState<any>(null);
  const [versionsDocument, setVersionsDocument] = useState<any>([]);
  const [customLoading, setCustomLoading] = useState(true);

  useEffect(() => {
    getItemsRequest({
      listName: myDocumentsListName,
      filters: { ID: documentCardID },
    }).then((resultsCard) => {
      getItemsRequest({
        listName: versionsByDocumentListName,
        filters: { MainDocument: documentCardID },
      }).then((resultsVersions) => {
        setVersionsDocument([...resultsVersions.items]);
        setCard(resultsCard.items.length > 0 && resultsCard.items[0]);
        getItemsRequest({ listName: copiesCardDocumentListName, filters: { DocumentID: documentCardID } }).then((results) => {
            console.log('MX-RESULT - ', results.items[0]);
          setCopies([...results.items]);
          setCustomLoading(false);
        })
      });
    });
  }, []);

  //Расчет индекса версии
  useEffect(() => {
    if (versionsDocument.length > 0 && Object.keys(card).length > 0) {
      let versionsIds: number[] = [];
      versionsDocument.map((version: any) => {
        versionsIds = [...versionsIds, version.ID];
      });
      let tempHistoryCard: any = [];
      getItemsRequest({
        listName: historyChangeFieldsDocumentListName,
        filters: {
          DocumentID: versionsIds,
          Statuses: [docStatuses.edited, docStatuses.sendApproval],
          VersionDocument: true,
        },
      }).then((results) => {
        tempHistoryCard = [...results.items];
        getItemsRequest({
          listName: historyChangeFieldsDocumentListName,
          filters: {
            DocumentID: documentCardID,
            Statuses: [docStatuses.edited, docStatuses.sendApproval],
            VersionDocument: false,
          },
        }).then((results) => {
          tempHistoryCard = [...tempHistoryCard, ...results.items];
          const historyCard = _.orderBy(
            Array.from(
              new Map(
                tempHistoryCard
                  .filter((history: any) =>
                    containsAllIds(history.Statuses, [
                      docStatuses.edited,
                      docStatuses.sendApproval,
                    ])
                  )
                  .map((item: any) => [item.DocumentID, item])
              ).values()
            ),
            "ID",
            "asc"
          );

          if (versionView) {
            historyCard.forEach((history: any, idx: number) => {
              if (
                history.DocumentID === Number(versionView) &&
                history.VersionDocument
              ) {
                setIndexVersion(idx + 1);
              }
            });
          } else {
            historyCard.forEach((history: any, idx: number) => {
              if (history.DocumentID === Number(documentCardID)) {
                setIndexVersion(idx + 1);
              }
            });
          }
        });
      });
    }
  }, [versionsDocument, card]);

  useEffect(() => {
    setDefaultValues((prevState: any) => {
      return {
        ...prevState,
        DateIssue: {
          startDate: new Date(),
          endDate: new Date(),
        },
        CopyNum:
          (copies.filter((copy: any) => Number(copy.Title) === indexVersion)
            .length === 0 &&
            1) ||
          copies.filter((copy: any) => Number(copy.Title) === indexVersion).length +
          1,
      };
    });
  }, [versionView, copies, indexVersion]);

  //Установка индекс версии по умолчанию в форме
  useEffect(() => {
    if (indexVersion) {
      setDefaultValues((prevState: any) => {
        return { ...prevState, Title: indexVersion };
      });
    }
  }, [indexVersion]);

  useEffect(() => {
    if (!edit) {
      setEditData(null);
      setDefaultValues((prevState: any) => {
        return {
          ...prevState,
          DateIssue: {
            startDate: new Date(),
            endDate: new Date(),
          },
          CopyNum:
            (copies.filter((copy: any) => Number(copy.Title) === indexVersion)
              .length === 0 &&
              1) ||
            copies.filter((copy: any) => Number(copy.Title) === indexVersion)
              .length + 1,
        };
      });
    }
  }, [edit]);

  // Если включено редактирование меняем значения по умолчанию
  useEffect(() => {
    if (edit && editData && Object.keys(editData).length > 0) {
      Object.keys(editData).map((key: string) => {
        let copy = editData[key];
        setDefaultValues((prevState: any) => {
          return {
            ...prevState,
            ...{
              ID: copy.ID,
              Comment: copy.Comment,
              Title: copy.Title,
              CopyNum: copy.CopyNum,
              From: [
                {
                  value:
                    (users[copy.From.get_email()] && users[copy.From.get_email()].email) ||
                    copy.From.get_email(),
                  label:
                    (users[copy.From.get_email()] &&
                      users[copy.From.get_email()].displayName) ||
                    copy.From.Name,
                  avatar:
                    (users[copy.From.get_email()] && users[copy.From.get_email()].avatar) ||
                    null,
                  email:
                    (users[copy.From.get_email()] && users[copy.From.get_email()].email) ||
                    copy.From.get_email(),
                },
              ],
              For: [
                {
                  value:
                    (users[copy.For.get_email()] && users[copy.For.get_email()].email) ||
                    copy.For.get_email(),
                  label:
                    (users[copy.For.get_email()] &&
                      users[copy.For.get_email()].displayName) ||
                    copy.For.Name,
                  avatar:
                    (users[copy.For.get_email()] && users[copy.For.get_email()].avatar) ||
                    null,
                  email:
                    (users[copy.For.get_email()] && users[copy.For.get_email()].email) ||
                    copy.For.get_email(),
                },
              ],
              DateIssue: {
                startDate: copy.DateIssue,
                endDate: copy.DateIssue,
              },
              Take:
                (copy.Take &&
                  moment(copy.Take).isValid() && {
                  startDate: copy.Take,
                  endDate: copy.Take,
                }) ||
                null,
            },
          };
        });
      });
    }
  }, [edit, editData]);

  useEffect(() => {
    if (formData && Object.keys(formData).length > 0) {
      setCustomLoading(true);
      const sendDataCopy: any = {
        Title: String(formData.Title),
        CopyNum: Number(formData.CopyNum),
        From: formData.From[0]["value"],
        For: formData.For[0]["value"],
        DateIssue:
          (typeof formData.DateIssue.startDate === "string" &&
            new Date(formData.DateIssue.startDate)) ||
          formData.DateIssue.startDate,
        Take:
          (formData.Take &&
            ((typeof formData.Take.startDate === "string" &&
              new Date(formData.Take.startDate)) ||
              formData.Take.startDate)) ||
          null,
        Comment: formData.Comment,
        DocumentID: Number(documentCardID),
      };
      if (formData.ID) {
        sendDataCopy["ID"] = formData.ID;
      }
      let requests: any = [];
      if (sendDataCopy.ID) {
        requests = [...requests, updateItemRequest({ listName: copiesCardDocumentListName, body: sendDataCopy })]
      } else {
        requests = [...requests, addItemRequest({ listName: copiesCardDocumentListName, body: sendDataCopy })]
      }
      Promise.all(requests).then(() => {
        setEditData(null);
        setEdit(false);
        setCreate(false);
        setFormData(null);
        getItemsRequest({ listName: copiesCardDocumentListName, filters: { DocumentID: documentCardID } }).then((results) => {
          setCopies([...results.items]);
          setCustomLoading(false);
        });
      });
    }
  }, [formData]);

  useEffect(() => {
    setDefaultValues((prevState: any) => {
      return {
        Title: indexVersion,
        DateIssue: {
          startDate: new Date(),
          endDate: new Date(),
        },
        CopyNum:
          (copies.filter((copy: any) => Number(copy.Title) === indexVersion)
            .length === 0 &&
            1) ||
          copies.filter((copy: any) => Number(copy.Title) === indexVersion)
            .length + 1,
      };
    });
  }, [copies, indexVersion]);

  useEffect(() => {
    if (copies.length > 0) {
      let usersEmail: any = [];
      // @ts-ignore
      copies.forEach((item: any) => {
        Object.keys(item).forEach((key) => {
          const field = item[key];
          if (field && !Array.isArray(field) && field.get_email) {
            if (field.get_email()) {
              usersEmail = [...usersEmail, field.get_email().toLowerCase()];
            }
          }
          if (
            field &&
            Array.isArray(field) &&
            field.length > 0 &&
            field[0].get_email
          ) {
            field.forEach((user) => {
              if (user.get_email()) {
                usersEmail = [
                  ...usersEmail,
                  user.get_email().toLowerCase(),
                ];
              }
            });
          }
        });
      });
      usersEmail = _.uniqWith(usersEmail, _.isEqual);
      if (usersEmail.length > 0) {
        let actualEmails: any = [];
        usersEmail.forEach((item: string) => {
          let check = false;
          Object.keys(users).forEach((key) => {
            if (key === item) {
              check = true;
            }
          });
          if (!check) {
            actualEmails = [...actualEmails, item.toLowerCase()];
          }
        });
        if (actualEmails) {
          dispatch(addUsers(actualEmails));
        }
      }
    }
  }, [copies]);

  return (
    <div className="relative overflow-x-auto sm:rounded-lg copiesCardDocument">
      <div className="w-full text-sm text-left rtl:text-right text-gray-500">

        {
          copies.length > 0 ? copies.map((item: any) => (
            <>
              <div key={item.ID} className="pt-5 flex items-start z-10 mb-2">
                <div className="w-2.5 h-2.5 bg-[#DFE4EA] rounded-full mr-4 mt-1.5"></div>
                <span className="text-[#637381] text-sm whitespace-nowrap">{moment(item.publishedAt).format("DD.MM.YYYY")}</span>
              </div>
              <div className="flex p-4 flex-col justify-center items-start w-full rounded-lg border border-solid border-[#DFE4EA] text-[#111928]">
                <div className="font-medium text-[13px] whitespace-nowrap mb-[9px]">№ версии {item.Title}</div>
                <div className="font-medium text-[13px] whitespace-nowrap mb-[9px]">№ копии {item.CopyNum}</div>
                <div className="mb-[8px]">
                  <div className="text-[13px] mb-[6px]">Кем выдан</div>
                  <div>
                    <span className="flex flex-row items-center gap-2">
                      <TooltipItem
                        className="-translate-x-1"
                        position="top-left"
                        tooltipsText={
                          users[item["From"].get_email()] &&
                          users[item["From"].get_email()].displayName
                        }
                      >
                        <UserAvatar
                          avatar={
                            users[item["From"].get_email()] &&
                            users[item["From"].get_email()].avatar
                          }
                          shortName={
                            users[item["From"].get_email()] &&
                            users[item["From"].get_email()].displayName &&
                            users[item["From"].get_email()].displayName.split(
                              " "
                            )[0][0] +
                            users[item["From"].get_email()].displayName.split(
                              " "
                            )[1][0]
                          }
                          displayName={
                            users[item["From"].get_email()] &&
                            users[item["From"].get_email()].displayName
                          }
                          email={item["From"].get_email()}
                        />
                      </TooltipItem>
                        {
                            users[item["From"].get_email()] &&
                            users[item["From"].get_email()].fullName
                        }
                    </span>
                  </div>
                </div>
                <div className="mb-[8px]">
                  <div className="text-[13px] mb-[6px]">Кому выдан</div>
                  <div>
                    <span className="flex flex-row items-center gap-2">
                      <TooltipItem
                        className="-translate-x-1"
                        position="top-left"
                        tooltipsText={
                          users[item["For"].get_email()] &&
                          users[item["For"].get_email()].displayName
                        }
                      >
                        <UserAvatar
                          avatar={
                            users[item["For"].get_email()] &&
                            users[item["For"].get_email()].avatar
                          }
                          shortName={
                            users[item["For"].get_email()] &&
                            users[item["For"].get_email()].displayName &&
                            users[item["For"].get_email()].displayName.split(
                              " "
                            )[0][0] +
                            users[item["For"].get_email()].displayName.split(
                              " "
                            )[1][0]
                          }
                          displayName={
                            users[item["For"].get_email()] &&
                            users[item["For"].get_email()].displayName
                          }
                          email={item["For"].get_email()}
                        />
                      </TooltipItem>
                            {
                                users[item["For"].get_email()] &&
                                users[item["For"].get_email()].fullName
                            }
                    </span>
                  </div>
                </div>
                <div className="mb-[8px]">
                  <div className="text-[13px]">Дата выдачи</div>
                  <div><span className="text-[#637381]">{moment(item.DateIssue).format("DD.MM.YYYY")}</span></div>
                </div>
                <div className="mb-[8px]">
                  <div className="text-[13px]">Комментарий</div>
                  <div><span>{item.Comment}</span></div>
                </div>
                <div className="mb-[8px]">
                  <div className="text-[13px]">Изъят</div>
                  <div>
                    {(item.Take && moment(item.Take).isValid() && (
                      <span className="text-[#637381]">{moment(item.Take).format("DD.MM.YYYY")}</span>
                      )) ||
                      (indexVersion !== Number(item.Title) && (
                        <span className="text-[#BA0C2F]">Не изъят</span>
                      ))}
                  </div>
                </div>
              </div>
            </>
          )) : (
            <div className="flex justify-center items-center w-full h-full">
              <div className="text-[#637381] text-sm">Копий не найдено</div>
            </div>
          )
        }
      </div>
    </div>
  );
};

export default CopiesCard;
